/*--------------------------------------------------------------------------\
  websocket.js

  Description
    The "WebSocket" object declaration.

  Copyrights- (C) Copyright 2007-2019 Software Consulting Services, LLC (SCS).
\--------------------------------------------------------------------------*/

/* Create a new WebSocket instance.
    If adding additional identities use the addNewIdentity function
      instead of creating a new instance. There should only be one
      instance of CASWebSocket initially created with the session id. */
function MoaiWebSocket(identity, callback, pageBound=true) {
  var $j = jQuery,
      $params = $j("#websocket-params"),
      notifyFunc = (isUndefinedOrNull(window.GrowlMessage)) ?
          notify:
          function(msg) { (new GrowlMessage({"message": msg, "sticky": true})).displayMessage() },
      messageCallbackList = [];

  var self = this;
  var portStr = "";
  if ( window.location.port != "" ) {
    portStr = ":" + window.location.port;
  }

  var url = "";
  // Use ws with http and wss with https to avoid browser security complaints.
  if ( window.location.protocol === "https:" ) {
    url = "wss://" + window.location.hostname + portStr + "/ws2";
  } else {
    url = "ws://" + window.location.hostname + portStr + "/ws2";
  }

  function isEquivalent(a, b) {
    // Check if two objects are basically the same. Used for matching broadcast filters
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length != bProps.length)
        return false;
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName])
            return false;
    }
    return true;
  }

  // Make a websocket
  try {
    var socket = new WebSocket(url);
  }
  catch (err) {
    console.log( "Failed to make web socket connection (" + err.message + ")!" );
    throw err;
  }

  socket.onopen = function(e) {
    console.log("WS: CASWebsocket Open");
    self.addNewCallback(identity, callback, pageBound);
  };

  socket.onerror = function(e) {
    console.error(e);
  };

  socket.onmessage = function(e) {
    var data = JSON.parse(e.data);
    var resp = data.params,
        message = resp.message,
        filter = resp.filter;
    console.log(filter, message);
    if (filter) {
      // Go through every callback registered for this page
      $j.each( messageCallbackList, function(i, callbackObj) {
        // Use the callback only if the filter matches exactly
        if ( isEquivalent(filter, callbackObj.identity) ) {
          var callbackFunc = function(message) {
            // If the callback returned true, remove it from the list
            if (callbackObj.callback(message)) {
              delete messageCallbackList[i];
            }
          };
          // Check if we are on the correct page to trigger the event
          if (isUndefinedOrNull(callbackObj.hash) || callbackObj.hash == CurrentHash) {
            callbackFunc(message);
          }
          else {
            // Don't trigger the callback;
            //    instead offer to navigate back to the page and then trigger it
            var $div = $("<div/>");
                $button = $('<button class="btn btn-info">Go to Page</button>');
            $div.append("<h5>" + callbackObj.title + "</h5>")
                .append("<h5><small>New Event Message:</small></h5>")
                .append("<pre>" + message + "</pre>")
                .append("<br/>").append($button);
            $button.click(function(e) {
              HashNavigate(callbackObj.hash);
              callbackFunc(message);
              $(e.currentTarget).parents("#alert-box").find("a.close").click();
            });
            notify($div, "info", true, 0, false);
          }
        }
      });
    } else {
      notifyFunc(message);
    }
  };

  /* Add a new callback to the page's current websocket.
     Do a check in with the ws server with the new indentity and
       then if a message with that identity comes in: call the
       callback using the message. */
  this.addNewCallback = function(identity, callback, pageBound=true) {
    var listEntry = {"identity": identity, "callback": callback};
    // Can only be page bound if on a bootstrap page
    if ( pageBound && !isUndefinedOrNull(window["CurrentHash"]) )
      $j.extend(listEntry, {"hash": CurrentHash, "title": document.title.substr(5)});
    messageCallbackList.push(listEntry);

    var jsonrpc = {
      "jsonrpc": "2.0",
      "method": "register",
      "params": listEntry.identity,
      "id": 0 };
    if ( this.isOpen() ) {
      socket.send(JSON.stringify(jsonrpc));
    }
  };

  /* This is used by the bootstrap pages to clear out websocket events
        when performing a hash navigation. It will remove socket callbacks
        with a hash that isn't accounted for in the page history. */
  this.clearCallbacks = function() {
    var hashHistory = __HISTORY_PAGE_CONTENT.map(function(e){return e.hash});
    hashHistory.push(CurrentHash);
    messageCallbackList = messageCallbackList.filter(function(e) {
      return isUndefinedOrNull(e.hash) ||
             hashHistory.indexOf(e.hash) != -1;
    });
  };

  this.close = function() {
    socket.close();
  }

  this.isOpen = function() {
    return socket.readyState === socket.OPEN;
  }
}

// END OF FILE: websocket.js
